module.exports = __webpack_public_path__ + "static/media/gloating-creamsicle.264e2601.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/gloating-creamsicle.png
// module id = 434
// module chunks = 0